import { createContext, useContext, useState, type ReactNode } from "react";
import { useAuth } from "@/hooks/useAuth";
import { alert } from "@/contexts/AlertModalContext";
import inovaone_api from "@/services/inovaone_api";
import type { LeitorResponseItem } from "@/types/leitor-response-item";

export type LeitoresContextType = {
  leitores: LeitorResponseItem[];
  coletaLeitores: () => Promise<void>;
};

export const LeitoresContext = createContext<LeitoresContextType | undefined>(
  undefined,
);

export function LeitoresProvider({ children }: { children: ReactNode }) {
  const { usuario } = useAuth();
  const [leitores, setLeitores] = useState<LeitorResponseItem[]>([]);

  const coletaLeitores = async () => {
    try {
      const response_leitores = await inovaone_api.get<LeitorResponseItem[]>(
        `/leitor/${usuario?.id_conta}/*/*/*/1`,
      );
      setLeitores(response_leitores.data);
    } catch (error) {
      console.error("Erro ao coletar leitores:", error);
      alert.error("Erro ao coletar leitores. Tente novamente mais tarde.");
    }
  };

  return (
    <LeitoresContext.Provider
      value={{
        leitores,
        coletaLeitores,
      }}
    >
      {children}
    </LeitoresContext.Provider>
  );
}

export function useLeitores() {
  const context = useContext(LeitoresContext);
  if (!context) {
    throw new Error("useLeitores deve ser usado dentro de um LeitoresProvider");
  }
  return context;
}
